import type { IGameService } from '../api.interface';
import type { CrashRecord, BetOutcome, SlotPreferences } from '../types';
import { StorageService, StorageKeys } from '../storage.service';
import { simulateLatency } from './latency';
import { MAX_HISTORY, MAX_BET_HISTORY } from '../../game/constants';

const DEFAULT_SLOT_PREFS: SlotPreferences = {
  amount: 10,
  autoBet: false,
  autoCashoutEnabled: false,
  autoCashoutValue: undefined,
};

export class MockGameService implements IGameService {
  async getCrashHistory(limit?: number): Promise<CrashRecord[]> {
    await simulateLatency();
    return StorageService.getList<CrashRecord>(StorageKeys.CRASH_HISTORY, limit);
  }

  async recordCrash(record: CrashRecord): Promise<void> {
    StorageService.appendToList(StorageKeys.CRASH_HISTORY, record, MAX_HISTORY);
  }

  async getBetHistory(limit?: number): Promise<BetOutcome[]> {
    await simulateLatency();
    return StorageService.getList<BetOutcome>(StorageKeys.BET_HISTORY, limit);
  }

  async recordBetOutcome(outcome: BetOutcome): Promise<void> {
    StorageService.appendToList(StorageKeys.BET_HISTORY, outcome, MAX_BET_HISTORY);
  }

  async getSlotPreferences(slotId: number): Promise<SlotPreferences> {
    await simulateLatency();
    const key = StorageKeys.SLOT_PREFS(slotId);
    return StorageService.getOrDefault<SlotPreferences>(key, DEFAULT_SLOT_PREFS) as SlotPreferences;
  }

  async updateSlotPreferences(slotId: number, prefs: Partial<SlotPreferences>): Promise<SlotPreferences> {
    await simulateLatency();
    const key = StorageKeys.SLOT_PREFS(slotId);
    const current = StorageService.getOrDefault<SlotPreferences>(key, DEFAULT_SLOT_PREFS) as SlotPreferences;
    const merged = { ...current, ...prefs };
    StorageService.set(key, merged);
    return merged;
  }
}
